<template>
<div>
<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<div class="mt-5">
<div class="grid">


<div class="col-12 md:col-3">
<span class="p-float-label">
<Dropdown v-model="selected_project_id" :options="projects" optionLabel="name" optionValue="id" 
     class="w-full p-inputtext-sm" @change="getFLows"/>

<label  class="text-primary">{{$store.state.languages.lang_phrases.proje}}</label>
</span>	
</div>

<div class="col-12 md:col-3">
<span class="p-float-label">
<Dropdown v-model="selected_flow_id" :options="flows" optionLabel="name" optionValue="id" 
     class="w-full p-inputtext-sm" @change="getPeriods"/>

<label  class="text-primary">{{$store.state.languages.lang_phrases.akis}}</label>
</span>	
</div>

<div class="col-12 md:col-3">
<span class="p-float-label">
<MultiSelect v-model="selected_period_ids" :options="periods" optionLabel="name" optionValue="id" 
     class="w-full p-inputtext-sm" @change="getData"/>

<label  class="text-primary">{{$store.state.languages.lang_phrases.proje_periyodu}}</label>
</span>	
</div>

<div class="col-12 md:col-3">
<span class="p-float-label">
<MultiSelect v-model="selected_statuses" :options="statuses"   display="chip"
     class="w-full p-inputtext-sm" @change="getData" />
     <label  class="text-primary">{{$store.state.languages.lang_phrases.durum}}</label>
</span>	
</div>

<div class="col-12 mt-5">
<template v-if="loading_flowsuppliers">
<FrameOverlay></FrameOverlay>
</template>



<template v-else>
<div class="grid">
<div class="col-12 md:col-5">
  <div class="grid " v-for="item in status_flowsuppliers ">
    <div class="col-4"><p><b>{{item.id}}:</b></p></div>
    <div class="col-2"><p class="text-primary font-bold">{{item.count}} adet</p></div>
    <div class="col-4"><p class="text-primary font-bold"> {{ $filters.numberformatShort( item.price)}} TL</p></div>

  </div>
  <div class="grid">
    <div class="col-4"><p><b>{{$store.state.languages.lang_phrases.toplam}}:</b></p></div>
    <div class="col-4"><p class="text-primary font-bold"> {{ $filters.numberformatShort( total)}} TL</p></div>
  </div>


</div>

<div class="col-12 md:col-7">
<Chart type="bar" :data="chartData" :options="barOptions" class="h-30rem" />

  </div>

</div>






</template>

</div>



</div>
</div>
</template>


</div>	
</template>


<script>
import moment from "moment"
const colors = ["#352f8d","#7e2f8d","#dd4b39","#4dc247","#3b82f6","#a82400","#ff6600"]
export default {

  name: 'BrandExpenses',

  data () {
    return {
    	loading:true,
    	loading_flowsuppliers:false,
    	projects:[],
    	flows:[],
    	periods:[],
    	flowsuppliers:[],
    	statuses:["created","viewed","started","finished","correction_requested","canceled","under_review"],
    	selected_statuses:[],
    	selected_project_id:null,
    	selected_flow_id:null,
    	selected_period_ids:[],
    	status_flowsuppliers:[],
      total:0,
      chartData:{
        labels:[],
        datasets:[]
      },
      barOptions: {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
                tooltips: {
                    mode: 'index',
                    intersect: false
                },
                legend: {
                    labels: {
                        color: "#352f8d"
                    }
                }
            },
            scales: {
                x: {
                    stacked: true,
                    ticks: {
                        color: "#7e2f8d"
                    },
                    grid: {
                        color: "#352f8d"
                    }
                },
                y: {
                    stacked: true,
                    ticks: {
                        color: "#7e2f8d"
                    },
                    grid: {
                        color: "#352f8d"
                    }
                }
            }
        },
    }
  },
  async mounted()
  {
  	this.loading = true
  	this.selected_statuses = await this.sanitizeArray(this.statuses)
  	this.projects = await this.generalApiGetWithoutLoader("brand_projects/"+this.$route.params.id)
  	this.loading = await false
  },
  methods:
  {
  	async getFLows()
  	{
  		this.flows = await this.generalApiGetWithoutLoader("project_flows/"+this.selected_project_id)
  		 
  	},
  	async getPeriods()
  	{
  		this.selected_period_ids = []
  		this.periods = await this.generalApiGetWithoutLoader("project_periods_for_expenses/"+this.selected_project_id+"/"+this.selected_flow_id)
  		console.log(this.periods)
  		let active = await this.periods.find((item)=>{return item.activeperiod ===1})
  		await this.selected_period_ids.push(active.id) 
  		this.getData()
  	},
  	async getData()
  	{
  		this.loading_flowsuppliers = true
  		this.flowsuppliers = await this.generalApiGetWithoutLoader("flowsuppliers_for_expenses/"+this.selected_flow_id+"?statuses="+JSON.stringify(this.selected_statuses)+"&periods="+JSON.stringify(this.selected_period_ids))
  		console.log(this.flowsuppliers)
  		this.parseFlowsuppliers()
  		this.loading_flowsuppliers = false  		
  	},
  	parseFlowsuppliers()
  	{
  		this.status_flowsuppliers = []
  		for(let status of this.selected_statuses)
  		{
  			let obj = {
  				id:status,
  				count:0,
  				price:0,
  			}
  			this.status_flowsuppliers.push(obj)
  		}
  		for(let flowsupplier of this.flowsuppliers) 
  		{
        //loop flowsuppliers
        flowsupplier.the_month = moment(flowsupplier.updated_at).startOf('month').format('MM-YYYY')
        flowsupplier.only_month = moment(flowsupplier.updated_at).startOf('month').format('MM')
  			let status_flowsupplier = this.status_flowsuppliers.findIndex((item)=>{return item.id == flowsupplier.status})
  			if(status_flowsupplier!==-1)
  			{
  				this.status_flowsuppliers[status_flowsupplier].count++
  				let period = this.periods.findIndex((item)=>{return item.id == flowsupplier.projectperiod_id})
  				
  				if(period !== -1 && this.periods[period].flowexpense)
  				{  					
  						this.status_flowsuppliers[status_flowsupplier].price += this.periods[period].flowexpense.price
  					
  					
  				}
  			}
  		}
      //loop flowsuppliers
      this.total = 0

      for(let item of this.status_flowsuppliers)
      {
        this.total += item.price
      }

      let groups = this.groupByMonths(this.flowsuppliers,"the_month")
       
      for(let group in groups)
      {
        //sconsole.log(groups[group])
        groups[group].push(this.groupByMonths(groups[group],"status"))  
      }
      console.log(groups)
      let startdate
      let enddate

      for(let theid of this.selected_period_ids)
      {
        let period = this.periods.find((item)=>{return item.id == theid})
        if(!startdate)
        {
          startdate = period.startdate
        }
        else
        {
          if(moment(startdate).isAfter(period.startdate))
          {
            startdate = period.startdate
          }
        }
        if(!enddate)
        {
          enddate = period.enddate
        }
        else
        {
          if(moment(enddate).isBefore(period.enddate))
          {
            enddate = period.enddate
          }
        } 
        
      }
      //diff = this.monthDiff(moment(startdate),moment(enddate))
      let diff =  moment(enddate).diff(startdate, 'months', true);
      this.chartData.labels = []
      this.chartData.datasets = []
      let color_counter = 0
      for(let item of this.selected_statuses)
      {
        this.chartData.datasets.push({
          label:item,
          type:"bar",
          backgroundColor:colors[color_counter],
          data:[]
        })
        color_counter++
      }

      let counter = 0
      while(diff+1>counter)
      {
       let label = moment(startdate).startOf('month').add(counter, 'M').format('MM-YYYY')
       this.chartData.labels.push(label)
       
       //console.log(groups[label][groups[label].length-1])
       //console.log(this.chartData.datasets[0])
       for(let selected_status of this.selected_statuses)
       {

        let dataset_ind =  this.chartData.datasets.findIndex((item)=>{return item.label == selected_status})
        
          if(groups[label])
          {
            let last = groups[label].slice(-1)
            console.log(last)
            if(last[0][selected_status])
            {
              this.chartData.datasets[dataset_ind].data.push(last[0][selected_status].length)
            }
            else
            {
              this.chartData.datasets[dataset_ind].data.push(0)
            }
            
          }
          else
          {
            this.chartData.datasets[dataset_ind].data.push(0)
          }
          
       }
       
        counter++
      }
      console.log(Math.ceil(diff))
      console.log(this.chartData.datasets)

  	},
    groupByMonths(xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    monthDiff(dateFrom, dateTo) {
     return dateTo.getMonth() - dateFrom.getMonth() + 
       (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
    },
  }
}
</script>

<style lang="css" scoped>
</style>